import React from 'react';
import { Observer, observer } from 'mobx-react';
import { observable } from 'mobx';
import { Dropdown } from './Dropdown';
import { UI_LANGUAGE } from '../../model/const';
import * as translate from '../../translate/actions'
import cookies from 'js-cookie';

import translateBase from '../../translate';
let _translate = translateBase.bindComponent('siteFooter');

const LanguageAnchor = ({ langCode }) =>
  <a className="language-dropdown-item" onClick={() => translate.setLanguage(langCode)}>
    {UI_LANGUAGE[langCode]}
  </a>

@observer
export class SiteFooter extends React.Component {
  @observable currentLanguage;
  componentDidMount() {
    this.currentLanguage = cookies.get('origamLanguage') || 'de-CH';
  }

  render() {
    return (
      <footer className="footer-container">
        <div className="wrapper">
          <div className="row">
            <div className="column-3">
              <img className="icon-container" src="/clients/standard/release/assets/content/logos/wyby-icon.svg" />
              <h2 className="claim">
                {_translate("claimText1", "Das umfassende")}
                <br />
                {_translate("claimText2", "Reservationssystem")}
                <br />
                {_translate("claimText3", "für Sie")}
              </h2>
            </div>
            <div className="column-3 offset-6">
              <Dropdown>{({ ref, isOpen, onOpen, onClose }) => <Observer>{() =>
                <div ref={ref} className="language-dropdown">
                  <a className="language small" onClick={onOpen}>
                    {UI_LANGUAGE[this.currentLanguage]} <i className="fa fa-caret-down" aria-hidden="true"></i>
                  </a>
                  <div className={"language-dropdown-content" + (isOpen ? " active" : "")}>
                    <LanguageAnchor langCode="de-CH" />
                    <LanguageAnchor langCode="en-US" />
                    <LanguageAnchor langCode="fr-CH" />
                    <LanguageAnchor langCode="cs-CZ" />
                  </div>
                </div>
              }</Observer>}</Dropdown>
              <a className="help small" href="https://wyby.ch/de-ch/Support/Anleitung" target="_blank"><i className="fa fa-question" aria-hidden="true"></i></a>
            </div>
          </div>
          <div className="row">
            <div className="column-12">
              <ul>
                <li><a href="https://wyby.ch/" target="_blank">© 2017 wy.by ag</a></li>
                <li><a href="https://wyby.ch/de-ch/Haftungsauschluss" target="_blank">Impressum</a></li>
              </ul>
            </div>
          </div>
        </div>
      </footer>
    )
  }
}


// WEBPACK FOOTER //
// ./src/visual/component/SiteFooter.js